import { Injectable } from '@angular/core';

import { Billing } from '../../models/billing';
import { Doc } from '../../models/doc';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class BillingService {
  url: string = 'billings';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

  create(billing: Billing, doc: Doc, activityRate: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { billing: billing, doc: doc, activity_rate: activityRate, matter_id: billing.matter_id });
  }

  getBillings(search_params: any): Promise<any> {
    search_params.search_billings = true;
    return this.httpClient.get(`${this.url}.json`, search_params);
  }

  getFormOptions(matter_id: number): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_form_options: true, matter_id: matter_id });
  }

  getRate(activity_id: number, user_id: number, matter_id: number, doc_activity_id: number): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { activity_id: activity_id, doc_activity_id: doc_activity_id, get_rate: 1, matter_id: matter_id, user_id: user_id });
  }

  getSearchOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_search_options: true });
  }

  getUsers(activity_id: number, matter_id: number): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { activity_id: activity_id, get_users_by_activity: true, matter_id: matter_id });
  }

  update(billing: Billing, doc: Doc, activityRate: any): Promise<any> {
    return this.httpClient.post(`${this.url}/${billing.id}.json`, { billing: billing, doc: doc, activity_rate: activityRate, matter_id: billing.matter_id });
  }
}
